import { useState, useEffect } from 'react';

const useInfiniteScroll = (hasMore, callback) => {
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = () => {
    if (window.innerHeight + document.documentElement.scrollTop < document.documentElement.offsetHeight - 1500 || isFetching || !hasMore) return;
    setIsFetching(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching) return;
    callback();
    setIsFetching(false);
  }, [isFetching]);

  return [isFetching, setIsFetching];
};

export default useInfiniteScroll;
